function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#252C32"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M33.348 26.679c-3.683 0-6.67-2.987-6.67-6.67v-4.447c-.005-3.788-2.41-7.156-5.991-8.392.279-.492.428-1.047.434-1.612 0-1.842-1.494-3.335-3.335-3.335-1.842 0-3.335 1.493-3.335 3.335.005.565.155 1.12.433 1.612-3.58 1.236-5.985 4.604-5.991 8.393v4.446c0 3.683-2.986 6.67-6.67 6.67v2.223H12.34c.528 2.588 2.805 4.447 5.447 4.446 2.7.166 5.075-1.768 5.458-4.446h10.104v-2.223zM16.674 5.558c0-.614.498-1.112 1.112-1.112.614 0 1.111.498 1.111 1.112 0 .614-.497 1.112-1.111 1.112s-1.112-.498-1.112-1.112zm1.112 25.567c-1.41-.004-2.665-.894-3.135-2.223h6.314c-.374 1.418-1.719 2.358-3.18 2.223zm-9.682-4.446c1.914-1.688 3.012-4.118 3.012-6.67v-4.447c0-3.683 2.986-6.67 6.67-6.67 3.683 0 6.67 2.987 6.67 6.67v4.447c0 2.552 1.097 4.982 3.012 6.67H8.104z",
  transform: "translate(-795 -2379) translate(795.286 2379.571)"
}))));

var SvgNotification = function SvgNotification(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNotification, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/notification.69bb1cce.svg";
export { ForwardRef as ReactComponent };